module.exports = __webpack_public_path__ + "media/images/entry/entry_btn2_ov-d9d26b70a61e67bd5907de4f72750dd0.gif";